var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72926 5.68418C1.35136 5.28142 0.718517 5.26127 0.315759 5.63916C-0.0869977 6.01706 -0.107152 6.6499 0.270744 7.05266L1.72926 5.68418ZM5.81482 11.5L5.08556 12.1842C5.28265 12.3943 5.56075 12.5092 5.84862 12.4994C6.1365 12.4897 6.4062 12.3563 6.58864 12.1334L5.81482 11.5ZM14.7738 2.13339C15.1236 1.70602 15.0608 1.07598 14.6334 0.72617C14.206 0.376357 13.576 0.439232 13.2262 0.866606L14.7738 2.13339ZM0.270744 7.05266L5.08556 12.1842L6.54407 10.8158L1.72926 5.68418L0.270744 7.05266ZM6.58864 12.1334L14.7738 2.13339L13.2262 0.866606L5.04099 10.8666L6.58864 12.1334Z",
    fill: "#1479FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.382fb133069fd68150d8840a373dcd7f.svg";
export { ForwardRef as ReactComponent };